import request   from '../Functions/ajax/request'


export default function BlogLoader ({ params })
{
	return { page: getNews(true, params), params };
}

async function getNews ()
{
	try
	{
		var actualite = await request('/news/get-latest')
		.config({ })
		.post();
	}
	catch (update)
	{
		console.error(update);
	}

	return actualite;
}